import { Api } from '@/interface/api';

/**
 * 获取参赛指南
 * @param accountId
 */
const getGuideList: Api = {
    url: '/api/project/proxy/api/v3/page-choices.json',
    method: 'get',
};

export { getGuideList };
